<template>
    <v-dialog v-model="show" max-width="500">
        <v-card v-if="purchase" class="v-card--dialog v-card--dialog--sm">
            <div class="v-card--dialog__head">
                <h3 class="tit tit--xs">{{ claimText }}요청</h3>
                <v-btn fab color="transparent" @click="close" class="v-card--dialog__close"><v-icon>mdi-close</v-icon></v-btn>
            </div>
            <div class="v-card--dialog__body">
                <v-row class="row--x-small">
                    <v-col cols="12">
                        <!-- <v-text-field v-model="reason" :placeholder="`${claimText} 사유`" outlined hide-details /> -->
                        <v-select v-model="reason" :items="reasonItems" placeholder="취소 사유" outlined hide-details />
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="demand" :placeholder="`${claimText} 요청 내용`" outlined hide-details />
                    </v-col>
                </v-row>
            </div>
            <div class="v-card--dialog__foot">
                <v-row class="row--x-small">
                    <v-spacer></v-spacer>
                    <v-col cols="auto">
                        <v-btn @click="claim" color="primary">{{ claimText }}요청</v-btn>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import api from "@/api";
export default {
    data() {
        return {
            show: false,

            purchase: null,
            claimType: null,
            reason: null,
            demand: null,
            reasonItems: []
        };
    },
    methods: {
        init() {
            this.purchase = null;
            this.claimType = null;
            this.reason = null;
            this.demand = null;
        },
        open() {
            this.show = true;
        },
        close() {
            this.show = false;
        },
        validate() {
            try {
                if (!this.demand) throw new Error(`${this.claimText} 사유 및 내용을 입력해주세요`);
                return true;
            } catch (error) {
                alert(error.message);
                return false;
            }
        },
        async search() {
            const { setting } = await api.v1.common.setting.get({});
            this.reasonItems = (setting?.cancelReasons || []).map(({ subject }) => ({ text: subject, value: subject }));
        },
        async claim() {
            if (this.validate()) {
                await api.v1.me.shop.purchases.claim(this.purchase._id, {
                    claimType: this.claimType,
                    reason: this.reason,
                    demand: this.demand,
                });
                alert(`${this.claimText}요청이 완료되었습니다`);
                this.$emit("claim");
                this.close();
            }
        },
    },
    computed: {
        claimText() {
            switch (this.claimType) {
                case "cancel":
                    return "취소";
                case "exhcnage":
                    return "교환";
                case "return":
                    return "반품";
            }
        },
    },
    watch: {
        show() {
            if (!this.show) {
                this.init();
            } else this.search();
        },
    },
};
</script>